import { render, staticRenderFns } from "./AnnualReport.vue?vue&type=template&id=7491c874&scoped=true"
import script from "./AnnualReport.vue?vue&type=script&lang=js"
export * from "./AnnualReport.vue?vue&type=script&lang=js"
import style0 from "./AnnualReport.vue?vue&type=style&index=0&id=7491c874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491c874",
  null
  
)

export default component.exports